import {
  RoomCollaboratorSchema,
  RoomSchema,
} from '../../../definitions/schemas';
import UserStore from '../../../stores/observables/UserStore';

export const isCurrentUserCollaborator = (
  collaborators: RoomCollaboratorSchema[]
) => {
  const currentUser = UserStore.get();
  return (
    !!currentUser &&
    collaborators.some(
      ({ collaboratorId }) => collaboratorId === currentUser.id
    )
  );
};

export const isRoomSummaryDisabled = (
  room?: RoomSchema | Partial<RoomSchema>
) =>
  !room?.welcomeMessage &&
  !room?.buttons?.length &&
  !room?.organization?.scheduleCall &&
  !room?.enableContactCard;
